import React from 'react';
import { useTranslation } from 'react-i18next';
import Paper from 'apollo-react/components/Paper';
import Select from 'apollo-react/components/Select';
import MenuItem from 'apollo-react/components/MenuItem';
import Grid from 'apollo-react/components/Grid';
import Calendar from 'apollo-react-icons/Calendar';
import Award from 'apollo-react-icons/Award';
import Email from 'apollo-react-icons/Email';
import User2 from 'apollo-react-icons/User2';
import Typography from '../StyledTypography';
import styles from './ClarificationWaves.module.css';

const ClarificationWavesHeader = ({
  selectedWave,
  waveOptions,
  onWaveChange,
  loadingWaveFormData,
  selectedWaveFormData,
}) => {
  const { t } = useTranslation();

  return (
    <Paper className={styles.headerPaper}>
      <div className={styles.headerContent}>
        <div className={styles.wavesLabelContainer}>
          <Typography variant="title" emphasis="default">
            {t('clarificationWaves.tabLabel')}
          </Typography>
        </div>
        <div className={styles.waveSelector}>
          <Select
            value={selectedWave}
            onChange={onWaveChange}
            placeholder={t('clarificationWaves.selectWavePlaceholder')}
            className={styles.select}
            disabled={loadingWaveFormData}
          >
            {waveOptions.map(({ value, label }) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </div>
      </div>
      {selectedWaveFormData && selectedWaveFormData.sentBackBy && (
        <div className={styles.sendBackSection}>
          <Typography
            variant="title"
            emphasis="default"
            className={styles.sendBackTitle}
          >
            {t('clarificationWaves.sendBackDetails')}
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <div className={styles.detailRow}>
                    <User2 className={styles.detailIcon} />
                    <div>
                      <Typography
                        variant="caption"
                        emphasis="low"
                        className={styles.detailLabel}
                      >
                        {t('clarificationWaves.userName')}
                      </Typography>
                      <Typography variant="bodySmall" emphasis="high">
                        {selectedWaveFormData.sentBackBy.username}
                      </Typography>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <div className={styles.detailRow}>
                    <Email className={styles.detailIcon} />
                    <div>
                      <Typography
                        variant="caption"
                        emphasis="low"
                        className={styles.detailLabel}
                      >
                        {t('clarificationWaves.userEmail')}
                      </Typography>
                      <Typography variant="bodySmall" emphasis="high">
                        {selectedWaveFormData.sentBackBy.email}
                      </Typography>
                    </div>
                  </div>
                </Grid>
                {selectedWaveFormData.sentBackBy.Role && (
                  <Grid item xs={12} sm={6} md={3}>
                    <div className={styles.detailRow}>
                      <Award className={styles.detailIcon} />
                      <div>
                        <Typography
                          variant="caption"
                          emphasis="low"
                          className={styles.detailLabel}
                        >
                          {t('clarificationWaves.userRole')}
                        </Typography>
                        <Typography variant="bodySmall" emphasis="high">
                          {selectedWaveFormData.sentBackBy.Role.name}
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                )}
                <Grid item xs={12} sm={6} md={3}>
                  <div className={styles.detailRow}>
                    <Calendar className={styles.detailIcon} />
                    <div>
                      <Typography
                        variant="caption"
                        emphasis="low"
                        className={styles.detailLabel}
                      >
                        {t('clarificationWaves.date')}
                      </Typography>
                      <Typography variant="bodySmall" emphasis="high">
                        {selectedWaveFormData.createdAt
                          ? new Date(
                              selectedWaveFormData.createdAt
                            ).toLocaleString()
                          : t('clarificationWaves.notAvailable')}
                      </Typography>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      )}
    </Paper>
  );
};

export default ClarificationWavesHeader;
